import { Container, Box, Typography, Paper, List, ListItem, ListItemText, Divider, Link } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  containerBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30vh',
  },
  paper: {
    padding: '16px',
    maxHeight: '52vh',
    overflow: 'auto',
  },
  errorText: {
    fontWeight: 600,
  },
  list: {
    padding: 0,
  },
  divider: {
    margin: '12px 0',
  },
}));

const HelpInstructions: React.FC = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="sm">
      <Box className={classes.containerBox}>
        <Paper elevation={1} className={classes.paper}>
          <Typography
            variant="subtitle2"
            color="error"
            gutterBottom
            className={classes.errorText}
          >
            Unable to connect to the backend
          </Typography>

          <Typography variant="h6" component="h4" gutterBottom>
            Sign-in help
          </Typography>

          <Typography variant="body2" paragraph>
            The application could not verify your session with the backend. Please follow these steps before retrying:
          </Typography>

          <List className={classes.list}>
            <ListItem>
              <ListItemText primary="Connect to Cisco VPN or AWS VPN." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Disable Zscaler for this session." />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Check if local network access is disabled in site permissions"
                secondary="A virtual private network can trigger private network access errors."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Clear cookies and site data."
                secondary="Remove old authentication tokens if login keeps failing."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Reload the page."
                secondary="Once your network is ready, refresh to retry connection."
              />
            </ListItem>
          </List>

          <Divider className={classes.divider} />

          <Typography variant="caption" color="textSecondary">
            If issue persists, reach out to us at{' '}
            <Link
              href="https://brightlysoftwaretech.slack.com/archives/C062XQF00QJ"
              target="_blank"
              rel="noopener"
            >
              #dev-services
            </Link>{' '}
            on Slack.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default HelpInstructions;
